import { computed } from '@vue/composition-api';
import QuotaPrice from '@/orm/models/Account/QuotaPrice';

export default function useQuotaPrice() {
  const quotaPrices = computed(() => QuotaPrice.all());

  async function fetchAll() {
    await QuotaPrice.api()
      .fetchAll();
  }

  function getQuotaByType(type) {
    return quotaPrices.value.find((q) => q.quotaType === type);
  }

  return {
    quotaPrices,
    fetchAll,
    getQuotaByType,
  };
}
